/*
  <skigrin-countdown> — aftelklok voor de announcement bar.

  Twee standen:
  - rolling: de deadline is een vast raster vanaf de epoch (bv. elke 12 uur), dus de
    teller loopt nooit af en elke bezoeker ziet hetzelfde. Bedoeld voor een werkversie.
  - fixed: een echte datum uit de theme editor.
*/
class SkigrinCountdown extends HTMLElement {
  connectedCallback() {
    this.fields = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    this.deadline = this.resolveDeadline();
    this.render();
    this.interval = setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  resolveDeadline() {
    if (this.dataset.mode === 'fixed' && this.dataset.deadline) {
      const parsed = Date.parse(this.dataset.deadline);
      if (!Number.isNaN(parsed)) return parsed;
    }

    const hours = parseFloat(this.dataset.rollingHours) || 12;
    const cycle = hours * 3600 * 1000;
    return Math.ceil(Date.now() / cycle) * cycle;
  }

  render() {
    let remaining = this.deadline - Date.now();

    if (remaining <= 0) {
      // In rolling-stand schuiven we door naar de volgende cyclus; in fixed-stand
      // blijft de teller op nul staan.
      if (this.dataset.mode !== 'fixed') {
        this.deadline = this.resolveDeadline();
        remaining = this.deadline - Date.now();
      } else {
        remaining = 0;
      }
    }

    const total = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };

    Object.keys(this.fields).forEach((key) => {
      const field = this.fields[key];
      if (!field) return;
      const next = key === 'days' ? String(values[key]) : String(values[key]).padStart(2, '0');
      if (field.textContent !== next) field.textContent = next;
    });
  }
}

if (!customElements.get('skigrin-countdown')) {
  customElements.define('skigrin-countdown', SkigrinCountdown);
}
